<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { loginStaff } from "@/utils/api_evento";

const router = useRouter();
const email = ref("");
const password = ref("");
const submitting = ref(false);
const errorMsg = ref("");

async function submit() {
  errorMsg.value = "";
  submitting.value = true;
  try {
    const data = await loginStaff({ email: email.value, password: password.value });
    localStorage.setItem("staff_access", data.access);
    localStorage.setItem("staff_refresh", data.refresh);
    localStorage.setItem("staff_nombre", data.user?.nombre || data.user?.email || "");
    router.push("/escaner");
  } catch (err) {
    errorMsg.value =
      err.response?.data?.detail ||
      err.response?.data?.non_field_errors?.[0] ||
      "Correo o contraseña incorrectos.";
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <div class="login-wrapper">
    <div class="glass-card">
      <div class="brand">
        <img src="@/assets/img/Evolve/EGPro.png" alt="EGPro" class="brand-logo" />
        <div class="brand-text">
          <p class="brand-title">Evolve Grappling Pro</p>
          <p class="brand-sub">Control de acceso</p>
        </div>
      </div>

      <form @submit.prevent="submit">
        <div class="field">
          <label>Correo electrónico</label>
          <div class="input-wrap">
            <i class="bi bi-envelope-fill"></i>
            <input
              v-model="email"
              type="email"
              placeholder="staff@evolve.com"
              autocomplete="email"
              required
            />
          </div>
        </div>

        <div class="field">
          <label>Contraseña</label>
          <div class="input-wrap">
            <i class="bi bi-lock-fill"></i>
            <input
              v-model="password"
              type="password"
              placeholder="••••••••"
              autocomplete="current-password"
              required
            />
          </div>
        </div>

        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>

        <button class="btn-login" type="submit" :disabled="submitting">
          <span v-if="!submitting">ACCEDER AL ESCÁNER</span>
          <span v-else class="spinner-border spinner-border-sm"></span>
        </button>
      </form>
    </div>
  </div>
</template>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap");

.login-wrapper {
  min-height: 100vh;
  font-family: "Inter", sans-serif;
  background: linear-gradient(rgba(15, 20, 30, 0.78), rgba(15, 20, 30, 0.88)),
    url("@/assets/img/background/image3.png");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
}

.glass-card {
  width: 100%;
  max-width: 420px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 24px;
  padding: 3rem 2rem;
}

.brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 2rem;
}
.brand-logo {
  height: 48px;
  width: auto;
}
.brand-title {
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  margin: 0;
  line-height: 1.2;
}
.brand-sub {
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin: 0;
}

.field {
  margin-bottom: 1.25rem;
}
label {
  display: block;
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 6px;
}

.input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.input-wrap i {
  position: absolute;
  left: 15px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 1rem;
}
.input-wrap input {
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px 12px 12px 42px;
  color: #fff;
  font-size: 14px;
  transition: border-color 0.2s;
  outline: none;
}
.input-wrap input:focus {
  border-color: rgba(255, 255, 255, 0.35);
}
.input-wrap input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.error-msg {
  color: #f87171;
  font-size: 0.85rem;
  margin-bottom: 0.75rem;
  text-align: center;
}

.btn-login {
  width: 100%;
  margin-top: 0.5rem;
  background: #f3bc2c;
  color: #0f172a;
  border: none;
  border-radius: 12px;
  padding: 14px;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.08em;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-login:hover:not(:disabled) {
  background: #e5ae24;
  transform: translateY(-1px);
}
.btn-login:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
